import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-border py-4 text-center text-xs text-muted-foreground">
      <div className="mx-auto flex max-w-3xl flex-wrap items-center justify-center gap-x-4 gap-y-1 px-4 lg:max-w-5xl">
        <span>{t('footer.copyright')}</span>
        <a href="#terms" className="hover:text-foreground underline-offset-4 hover:underline">
          {t('footer.terms')}
        </a>
        <a href="#privacy" className="hover:text-foreground underline-offset-4 hover:underline">
          {t('footer.privacy')}
        </a>
      </div>
    </footer>
  );
}
